import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import PropTypes from 'prop-types';
import uuidv4 from 'uuid';

//actions:
import { openDialog, hideDialog } from '../../actions/index';
import { getData } from '../../dataLib';

//components:
import NeuriteGrid from '../../components/neurite_grid';

//material ui:
import { withStyles } from '@material-ui/core/styles';
import CircularProgress from '@material-ui/core/CircularProgress';
import Button from '@material-ui/core/Button';

const styles = theme => ({
    root: {
        margin: theme.spacing(2)
    },
    button: {
        margin: '15px 8px',
        padding: '10px 4%',
        borderRadius: 0,
        textTransform: 'capitalize',
        color: 'white',
        border: 'none',
        boxShadow: 'none',
    },
    formControl: {
        margin: theme.spacing(1),
        minWidth: 120,
    },
    textField: {
        marginLeft: theme.spacing(1),
        marginRight: theme.spacing(1),
        width: 200,
    },
    Typography: {
        margin: 'auto'
    },
    spinnerContainer: {
        width: '95%',
        height: 300,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
    },
    spinner: {
        width: '50px !important',
        height: '50px !important',
    },
    divData: {
        position: 'relative'
    },
    cover: {
        position: 'absolute',
        height: '100%',
        width: 525,
        marginLeft: 8,
        zIndex: 1,
        backgroundColor: '#ddd',
        opacity: 0.3,
    },
});

class IngresosBanco extends React.PureComponent {

    constructor(props) {
        super(props);
        this.state = {
            ingresos: [],
            showSpinner: true
        }
    }

    componentDidUpdate(prevProps) {
        if (this.producto === undefined &&
            prevProps.centroDiaSelected !== this.props.centroDiaSelected) {
            this.getIngresos();
        }

        if (prevProps.centroDiaSelected.dia !== this.props.centroDiaSelected.dia || prevProps.centroDiaSelected.centro !== this.props.centroDiaSelected.centro)
            this.setState({ ...this.state, showSpinner: true })
    }

    editIngreso = (ingreso) => {
        this.props.openDialog('Arqueo', {
            centroId: this.props.centroDiaSelected.centro.id,
            fecha: ingreso.fecha,
            okHandler: (total) => {
                const newIngresos = this.state.ingresos.map((i) => {
                    if (i.fecha === ingreso.fecha) {
                        return { ...i, sumReal: total };
                    }
                    else return i;
                });
                this.setState({ ingresos: newIngresos })
            },
            disabled: this.props.isSemanaCerrada
        }, uuidv4(), true, "xs")
    }

    //obtiene las lecturas de los contadores
    getIngresos = () => {

        let ingresosURL = 'VIngresosResumen?centro_id=' + this.props.centroDiaSelected.centro.id + '&date=' + this.props.centroDiaSelected.dia

        getData(ingresosURL,
            (response) => {
                this.setState({ ...this.state, ingresos: response.data, showSpinner: false })
            },
            (error) => {
                this.props.openDialog('SimpleMessage', {
                    message: 'ERROR fetching ingresos banco'
                }, uuidv4(), false, 'sm');
            },
            this.props.user
        );

    }

    componentDidMount = () => {
        this.getIngresos();
    }

    render() {
        const { classes } = this.props;

        if (this.state.showSpinner)
            return (
                <div className={classes.spinnerContainer}>
                    <CircularProgress className={classes.spinner} color="primary" />
                </div>
            );
        return (
            <div className={classes.divData}>
                <div className={classes.cover} style={{ display: this.props.centroDiaSelected.isValid ? 'none' : 'block' }} ></div>
                <NeuriteGrid
                    id="i_b"
                    columns={[
                        { key: 'fecha', name: 'Fecha', editable: false, dragable: false, type: 'date', width: 80 },
                        { key: 'sumTeorico', name: 'Teórico', tooltip: 'Ingresos teóricos según cajas diarias', editable: false, dragable: false, type: 'float', width: 75 },
                        { key: 'sumReal', name: 'Real', tooltip: 'Ingresos reales según arqueo', editable: false, dragable: false, type: 'float', width: 75 }
                    ]}
                    rows={this.state.ingresos}
                    buttonEdit={!this.props.isSemanaCerrada}
                    buttonDelete={false}
                    buttonNew={false}
                    onEditClick={this.editIngreso}
                    height={300}
                />

                <div className={classes.bottomBtn}>
                    {this.props.isDialog ?
                        <Button
                            variant="contained"
                            color="secondary"
                            className={classes.button}
                            onClick={() => { this.props.hideDialog() }}
                            disabled={!this.props.centroDiaSelected.isValid}
                        >
                            Cerrar
                    </Button>
                        : ''}
                </div>
            </div>
        );
    }
}


IngresosBanco.propTypes = {
    //state
    centroDiaSelected: PropTypes.object.isRequired,
    isSemanaCerrada: PropTypes.bool.isRequired,
    user: PropTypes.object.isRequired,
    isDialog: PropTypes.bool,
    //dispatch
    hideDialog: PropTypes.func.isRequired,
    openDialog: PropTypes.func.isRequired,

};

function mapStateToProps(state) {
    return {
        centroDiaSelected: state.centroDiaSelected,
        isSemanaCerrada: state.centroDiaSelected.isSemanaCerrada,
        user: state.oidc.user
    };
}

function mapDispathToProps(dispatch) {
    return bindActionCreators({
        hideDialog,
        openDialog,
    }, dispatch);
}


export default connect(
    mapStateToProps,
    mapDispathToProps
)(withStyles(styles, { withTheme: true })(IngresosBanco));